import Network from '@/services/network'

export default function handleOnlinePayment() {
    const network = new Network();

    const fetchSubscriptions = (query = '') => {
        return network.api('GET', `online-payment/subscriptions${query}`);
    }

    const initiatePayment = (data) => {
        return network.api('POST', 'online-payment/initiate', data);
    }

    const fetchSubscriptionInvoice = (subscriptionId, query = '') => {
        return network.api('GET', `/online-payment/subscriptions/${subscriptionId}/print-invoice${query}`);
    }

    const initiateSubscriptionPayment = (data) => {
        return network.api('POST', `/online-payment/subscriptions/initiate-payment`, data);
    }

    const fetchSubscriptionReceipt = (subscriptionId, query = '') => {
        return network.api('GET', `/online-payment/subscriptions/${subscriptionId}/receipt${query}`);
    }

    return {
        fetchSubscriptions,
        initiatePayment,
        fetchSubscriptionInvoice,
        initiateSubscriptionPayment,
        fetchSubscriptionReceipt
    }
}
